import { apiUrl } from "../../../../Constant/apiConstant"
import { postFormRequest, postJsonRequest } from "../../../../service/apiService"

export const getCandidateOfferLetter = async (tenant: undefined | string, payLoad: any, isCandidate: boolean) => {
    try {
        const response = await postJsonRequest(apiUrl.JM_GET_CANDIDATE_OFFER_LETTER, payLoad, tenant, true, undefined, isCandidate);

        if (response.status === 200) {
            const { Status, Data } = response.data;

            return Status ? Data : null
        }
    } catch (error) {
        console.log(error)
    }
    return null
}

export const updateCandidateOfferLetter = async (tenant: undefined | string, payLoad: any) => {
    try {
        const response = await postJsonRequest(apiUrl.JM_POST_UPDATE_CADIDATE_OFFER_LETTER, payLoad, tenant);

        if (response.status === 200) {
            const { Status, Data, Message } = response.data;

            return { Data, Message, Status }
        }
    } catch (error) {
        console.log(error)
    }
    return null
}

export const sendOtp = async (tenant: undefined | string, payLoad: any) => {
    try {
        const response = await postJsonRequest(apiUrl.JM_SEND_OTP, payLoad, tenant, false);

        if (response.status === 200) {
            const { Status, Message } = response.data;

            return { Message, Status }
        }
    } catch (error) {
        console.log(error)
    }
    return null
}

export const uploadCandidateOfferLetterFile = async (tenant: undefined | string, formData: any) => {
    try {
        const response = await postFormRequest(apiUrl.JM_POST_UPLOAD_CANDIDATE_OFFER_LETTER_FILE, formData, tenant);

        if (response.status === 200) {
            const { Status, Message } = response.data;

            return { Message, Status }
        }
    } catch (error) {
        console.log(error)
    }
    return null
}

export const deleteCandidateOfferLetterFile = async (tenant: undefined | string, payLoad: any) => {
    try {
        const response = await postJsonRequest(apiUrl.JM_POST_DELETE_CANDIDATE_OFFER_LETTER_FILE, payLoad, tenant);

        if (response.status === 200) {
            const { Status, Message } = response.data;

            return { Message, Status }
        }
    } catch (error) {
        console.log(error)
    }
    return null
}

export const validateOtp = async (tenant: undefined | string, payLoad: any) => {
    try {
        const response = await postJsonRequest(apiUrl.JM_POST_VALIDATE_OTP, payLoad, tenant, false);

        if (response.status === 200) {
            const { Status, Message, CandidateAccessToken,PreboardingStatus } = response.data;

            return { Message, Status, CandidateAccessToken ,PreboardingStatus}
        }
    } catch (error) {
        console.log(error)
    }
    return null
}

export const getCandidateData = async (tenant: undefined | string, payLoad: any, isCandidate: boolean) => {
    try {
        const response = await postJsonRequest(apiUrl.JM_GET_CANDIDATE_DATA, payLoad, tenant, true, undefined, isCandidate);

        if (response.status === 200) {
            const { Status, Data } = response.data;

            return Status ? Data : null
        }
    } catch (error) {
        console.log(error)
    }
    return null
}

export const downloadCandidateOfferLetterPdf = async (tenant: undefined | string, payLoad: any, isCandidate: boolean) => {
    try {
        const response = await postJsonRequest(apiUrl.JM_GET_DOWNLOAD_CANDIDATE_OFFER_LETTER_PDF, payLoad, tenant, true, 'blob', isCandidate);

        if (response.status === 200) {
            return response
        }
    } catch (error) {
        console.log(error)
    }
    return null
}

export const declineCandidateOfferLetter = async (tenant: undefined | string, payLoad: any, isCandidate: boolean) => {
    try {
        const response = await postJsonRequest(apiUrl.JM_POST_CANDIDATE_OFFER_LETTER_DECLINE, payLoad, tenant, true, undefined, isCandidate);

        if (response.status === 200) {
            const { Status, Message } = response.data;

            return { Message, Status }
        }
    } catch (error) {
        console.log(error)
    }
    return null
}

export const acceptCandidateOfferLetter = async (tenant: undefined | string, payLoad: any, isCandidate: boolean) => {
    try {
        const response = await postJsonRequest(apiUrl.JM_POST_CANDIDATE_OFFER_LETTER_ACCEPT, payLoad, tenant, true, undefined, isCandidate);

        if (response.status === 200) {
            const { Status, Message } = response.data;

            return { Message, Status }
        }
    } catch (error) {
        console.log(error)
    }
    return null
}

export const addOrUpdateCandidateDetails = async (tenant: string | undefined, payLoad: any, isCandidate: boolean) => {
    try {
        const response = await postJsonRequest(apiUrl.JM_POST_ADD_OR_UPDATE_CANDIDATE_DETAILS, payLoad, tenant, true, undefined, isCandidate);

        if (response.status === 200) {
            const { Status, Message } = response.data;

            return { Message, Status }
        }
    } catch (error) {
        console.log(error)
    }
    return null
}

export const getCandidateCustomFieldValues = async (tenant: undefined | string, payLoad: any, isCandidate: boolean) => {
    try {
        const response = await postJsonRequest(apiUrl.JM_GET_CANDIDATE_CUSTOM_FIELD_VALUES, payLoad, tenant, true, undefined, isCandidate);

        if (response.status === 200) {
            const { Status, Data } = response.data;

            return Status ? Data : null
        }
    } catch (error) {
        console.log(error)
    }
    return null
}

export const deleteEmploymentHistory = async (tenant: undefined | string, payLoad: any, isCandidate: boolean) => {
    try {
        const response = await postJsonRequest(apiUrl.JM_POST_DELETE_EMPLOYMENT_HISTORY, payLoad, tenant, true, undefined, isCandidate);

        if (response.status === 200) {
            const { Status, Message } = response.data;

            return { Message, Status }
        }
    } catch (error) {
        console.log(error)
    }
    return null
}

export const getCandidateDocuments = async (tenant: undefined | string, payLoad: any, isCandidate: boolean) => {
    try {
        const response = await postJsonRequest(apiUrl.JM_GET_CANDIDATE_DOCUMENTS, payLoad, tenant, true, undefined, isCandidate);

        if (response.status === 200) {
            const { Status, Documents, Sections, HasExperience, EmploymentHistory } = response.data;

            return Status ? { Documents, Sections, HasExperience, EmploymentHistory } : null
        }
    } catch (error) {
        console.log(error)
    }
    return null
}

export const addCandidateDocuments = async (tenant: undefined | string, formData: any, isCandidate: boolean) => {
    try {
        const response = await postFormRequest(apiUrl.JM_POST_ADD_CANDIDATE_DOCUMENTS, formData, tenant, true, undefined, isCandidate);

        if (response.status === 200) {
            const { Status, Message } = response.data;

            return { Message, Status }
        }
    } catch (error) {
        console.log(error)
    }
    return null
}

export const submitCandidateDocuments = async (tenant: undefined | string, payLoad: any, isCandidate: boolean) => {
    try {
        const response = await postJsonRequest(apiUrl.JM_POST_SUBMIT_CANDIDATE_DOCUMENTS, payLoad, tenant, true, undefined, isCandidate);
        if (response.status === 200) {
            const { Status, Message } = response.data;
            return { Message, Status }
        }
    } catch (error) {
        console.log(error)
    }
    return null
}

export const deleteCandidateDocument = async (tenant: undefined | string, payLoad: any, isCandidate: boolean) => {
    try {
        const response = await postJsonRequest(apiUrl.JM_POST_DELETE_CANDIDATE_DOCUMENT, payLoad, tenant, true, undefined, isCandidate);

        if (response.status === 200) {
            const { Status, Message } = response.data;

            return { Message, Status }
        }
    } catch (error) {
        console.log(error)
    }
    return null
}

export const deleteEmploymentHistoryDocument = async (tenant: undefined | string, payLoad: any, isCandidate: boolean) => {
    try {
        const response = await postJsonRequest(apiUrl.JM_POST_DELETE_EMPLOYMENT_HISTORY_DOCUMENT, payLoad, tenant, true, undefined, isCandidate);

        if (response.status === 200) {
            const { Status, Message } = response.data;

            return { Message, Status }
        }
    } catch (error) {
        console.log(error)
    }
    return null
}

export const downloadCandidateDocument = async (tenant: undefined | string, payLoad: any, isCandidate: boolean) => {
    try {
        const response = await postJsonRequest(apiUrl.JM_GET_DOWNLOAD_CANDIDATE_DOCUMENT, payLoad, tenant, true, 'blob', isCandidate);
        if (response.status === 200) {
            return response
        }
    } catch (error) {
        console.log(error)
    }
    return null
}

export const downloadAllCandidateDocumentsZip = async (tenant: undefined | string, payLoad: any) => {
    try {
        const response = await postJsonRequest(apiUrl.JM_GET_DOWNLOAD_ALL_CANDIDATE_DOCUMENTS_ZIP, payLoad, tenant, true, 'blob');

        if (response.status === 200) {
            return response
        }
    } catch (error) {
        console.log(error)
    }
    return null
}


export const verifyCandidateDocument = async (tenant: undefined | string, payLoad: any) => {
    try {
        const response = await postJsonRequest(apiUrl.JM_POST_VERIFY_CANDIDATE_DOCUMENT, payLoad, tenant, true, undefined);
        if (response.status === 200) {
            const { Status, Message, Data } = response.data;

            return { Message, Status, Data }
        }
    } catch (error) {
        console.log(error)
    }
    return null
}


export const completeCandidateDocumentsVerification = async (tenant: undefined | string, payLoad: any) => {
    try {
        const response = await postJsonRequest(apiUrl.JM_POST_COMPLETE_CANDIDATE_DOCUMENTS_VERIFICATION, payLoad, tenant, true, undefined);
        if (response.status === 200) {
            const { Status, Message } = response.data;
            return { Message, Status }
        }
    } catch (error) {
        console.log(error)
    }
    return null
}

export const saveHiringExperience = async (tenant: string | undefined, payLoad: any, isCandidate: boolean) => {
    try {
        const response = await postJsonRequest(apiUrl.JM_POST_SAVE_HIRING_EXPERIENCE, payLoad, tenant, true, undefined, isCandidate);

        if (response.status === 200) {
            const { Status, Message } = response.data;
            return { Message, Status }
        }
    } catch (error) {
        console.log(error)
    }
    return null
}

export const completeBgv = async (tenant: string | undefined, payLoad: any) => {
    try{
        const response = await postJsonRequest(apiUrl.JM_POST_COMPLETE_BGV, payLoad, tenant, true);
        if (response.status === 200) {
            const { Status, Message } = response.data;
            return { Message, Status }
        }
    }catch(error){
        console.log(error)
    }
    return null
}